import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from "react-router-dom"
import { HelmetProvider } from "react-helmet-async";
import './index.css';
import App from './App';
import { LocaleProvider } from './context/LocaleContext';
import { BookAppointmentModalProvider } from './context/BookAppointmentModalContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <HelmetProvider>
      <LocaleProvider>
        <BookAppointmentModalProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </BookAppointmentModalProvider>
      </LocaleProvider>
    </HelmetProvider>
    
);

